<template>
  <div class='product-hdbb product-container product-strength-count-6'>
    <banner :data='banner'></banner>
    <div class='product-content'>
      <div class='section'>
        <strength :ourstrengths='strength'></strength>
      </div>
      <div class='section'>
        <use-case :usecase="scene"></use-case>
      </div>
      <div class='section'>
        <why-choose></why-choose>
      </div>
      <div class='section'>
        <price></price>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '../../components/banner.vue';
import Strength from '../../components/solution/our_strengths.vue';
import UseCase from '../../components/solution/use_case.vue';
import WhyChoose from '../../components/solution/why_choose.vue';
import { CONSOLE_SITE_URL } from '../../utils/constants';
import Price from './components/price.vue';

export default {
  metaInfo: {
    title: '互动白板-白板教学SDK-马兰头医学科技',
    meta: [
      {
        name: 'keywords',
        content: '互动白板,在线教学,webrtc,白板教学,白板SDK'
      },
      {
        name: 'description',
        content: '马兰头医学科技矢量化全互动白板，支持多端同时书写，音视频流与白板绘制毫秒级同步，为互动教学而生，个性化定制支持更多功能实现'
      },
    ]
  },
  components: {
    Banner,
    Strength,
    UseCase,
    WhyChoose,
    Price,
  },
  data() {
    return {
      banner: {
        title: '互动白板',
        desc: '矢量化全互动白板，支持多端同时书写，毫秒级同步，为互动教学而生',
        image: require('../../assets/product/03.png'),
        buttonText: '立即体验',
        buttonCallback: () => {
          window.open(CONSOLE_SITE_URL);
        }
      },
      strength: {
        title: '专为互动教学而生',
        content: [{
            title: '矢量化放大',
            intro: '无论放大几倍，保证清晰不模糊，最高1080P画质支持',
            img: require('@/assets/product/40.png')
          },{
            title: '低带宽占用',
            intro: '从底层优化信令服务，降低白板对带宽和内存的占用。更少流量，更高清晰度',
            img: require('@/assets/product/41.png')
          },{
            title: '实时同步低延时',
            intro: '音视频流与白板绘制的对齐同步，毫秒级延时',
            img: require('@/assets/product/42.png')
          },{
            title: '高交互体验',
            intro: '支持多端同时书写多页白板，可实现百人同时高效互动协作，真正线下课堂体验',
            img: require('@/assets/product/43.png')
          },{
            title: '多类型文档支持',
            intro: '支持多类型文件，兼容格式与尺寸，满足在线协作需求',
            img: require('@/assets/product/44.png')
          },{
            title: '个性化定制',
            intro: '满足更多功能需求，减少企业自身开发成本',
            img: require('@/assets/product/45.png')
          },
        ]
      },
      scene: {
        title: '使用场景',
        content: [{
            title: '在线教学',
            subtitle: '1对1小班课，双师课堂…课件、白板、音视频实时同步交流，全面提升教学互动性',
            img: require('@/assets/product/71.png')
          }, {
            title: '线上协作',
            subtitle: '线上会议协作，方案、流程图、项目表等多方实时协作',
            img: require('@/assets/product/72.png')
          }, {
            title: '线上绘图',
            subtitle: '多种画笔类型选择，橡皮擦清除功能等，适合你画我猜、美术教学等场景',
            img: require('@/assets/product/73.png')
          }
        ]
      }
    }
  },
}
</script>

<style lang="less" scoped>
</style>